module.exports = __webpack_public_path__ + "static/media/deleteIcon.554b3991.svg";